import i18n from '../translations/i18n';

export const getErrorMessage = error => {
    if(error.message === 'Network Error') {
        return i18n.t('common:errors.noConnection');
    } else if(error.response && error.response.data && error.response.data.result && error.response.data.result.message) {
        return error.response.data.result.message;
    } else if(typeof error === 'string') {
        return error
    } else {
        console.warn(error);
        return i18n.t('common:errors.internalError');
    }
};